import React, { useState, MouseEvent } from "react";
import { Button, Menu, MenuItem, IconButton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import { useNavigate } from "react-router-dom";

interface ActionsButtonProps {
    params: {
        row: {
            id: number;
            username: string;
            email: string;
            status: string;
            lastLogin: string;
            industry: string;
            experience: string;
        };
    };
}

function ActionsButton({ params }: ActionsButtonProps) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleViewDetails = () => {
        navigate(`/admin/accounts/${params.row.id}`, { state: { user: params.row } });
        handleClose();
    };

    const handleDeleteAccount = () => {
        // console.log("Delete account:", params.row);
        handleClose();
    };

    const handleDeactivateAccount = () => {
        // console.log("Deactivate account:", params.row);
        handleClose();
    };

    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreHorizIcon />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={handleViewDetails}>
                    <VisibilityIcon fontSize="small" style={{ marginRight: 8 }} />
                    View details
                </MenuItem>
                <MenuItem onClick={handleDeleteAccount} style={{ color: "red" }}>
                    <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
                    Delete account
                </MenuItem>
                <MenuItem onClick={handleDeactivateAccount}>
                    <BlockIcon fontSize="small" style={{ marginRight: 8 }} />
                    Deactivate account
                </MenuItem>
            </Menu>
        </>
    );
}

export default ActionsButton;
